import { Context } from '@/models/order-history/status/context/context'
import { paymentTypeIsExternalPayment } from '@/models/order-history/status/context/payment-type'
import { ForCvsNumber } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/commands/for-cvs-number'
import { ForDefault } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/commands/for-default'
import { ForNpPostpay } from '@spa/components/organisms/mypage/order/model/order-cancellation-state/commands/for-np-postpay'

export type OrderCancellationState = CancellableState | NotCancellableState

interface CancellableState {
  isCancellable: true
}

interface NotCancellableState {
  isCancellable: false
  /**
   * キャンセルボタンを表示する場所に変わりに表示するテキスト
   * キャンセルできないからと言って必ずメッセージが存在するわけではない
   *
   * FIXME:
   * 意味的にはOrderStatusViewModel.descriptionと部分的に重複するので整理したい
   */
  messageForNotCancellable?: string
}

export function cancelIsAcceptable(state: OrderCancellationState): state is CancellableState {
  return state.isCancellable
}

export function cancelIsNotAcceptable(state: OrderCancellationState): state is NotCancellableState {
  return !cancelIsAcceptable(state)
}

export function getOrderCancellationState(
  context: Context,
  isPreOrder: boolean
): OrderCancellationState {
  if (isPreOrder) {
    /**
     * @see https://github.com/my-color/front/issues/98 予約注文はキャンセル不可
     */
    return {
      isCancellable: false,
      messageForNotCancellable: '予約商品のご注文はキャンセルできません',
    }
  }

  const forNpPostpay = new ForNpPostpay()
  if (forNpPostpay.shouldApply(context)) {
    return forNpPostpay.execute(context)
  }
  const forCvsNumber = new ForCvsNumber()
  if (forCvsNumber.shouldApply(context)) {
    return forCvsNumber.execute(context)
  }

  return new ForDefault().execute(context)
}

/**
 * TODO:
 * その名に反して決済待ちの状態は再注文不可（「ご注文情報登録中は再注文できません」）の判定にのみ利用されている
 * キャンセル可否とは切り離し、再注文可否の判定及び再注文を受け付けられない場合のメッセージを返却する関数として定義し直したほうがよいかもしれない
 */
export function getIsBeforeCancellable(
  context: Pick<Context, 'engineStatus' | 'paymentType'>
): boolean {
  /**
   * 既存実装で外部決済の決済待ちはエラー表示として扱っていたのでそのまま踏襲しているが、
   * 再決済の実装に伴って適切な表示は変わってくるはず。
   */
  if (paymentTypeIsExternalPayment(context.paymentType)) {
    return false
  }

  return context.engineStatus === 'payment-requested'
}
